import loadable from '@loadable/component'
import { optimizedImgixUrl } from '@uswitch/comms-ui.image'
import React from 'react'

import BlackFridayImage from '~/components/black-friday/hero-image'
import { useInBucket } from '~/hooks/use-in-bucket'
import { notEmpty } from '~/utils/empty'

import { getHeroBackgroundColour } from './config'
import * as st from './styles'

const CommsUiHero = loadable(() => import('@uswitch/comms-ui.homepage-layout'), {
  resolveComponent: (components) => components.Hero
})

const HeroContainer = ({ children }) => (
  <div sx={st.containerStyle} className='broadband-hero'>
    {children}
  </div>
)

const HeroImageP0 = ({ hideP0Image = false, imageUrl = '' }) => {
  if (!imageUrl || hideP0Image) return null

  return (
    <picture style={st.p0PictureStyle}>
      <source srcSet='data:image/gif;base64,R0lGODlhAQABAAD/ACwAAAAAAQABAAACADs=' media='(max-width: 1199px)' />
      <img src={optimizedImgixUrl(imageUrl)} style={{ height: '100%' }} alt='' />
    </picture>
  )
}

const HeroImageBlackFriday = ({ hasP0 = false, showImage = true }) => {
  if (!showImage) return null

  return (
    <BlackFridayImage
      hasP0={hasP0}
      className='black-friday-image'
      sx={hasP0 ? { ...st.blackFridayImage, ...st.hasP0 } : st.blackFridayImage}
    />
  )
}

const Hero = ({ p0 = {}, p0Fetched = { current: true }, hideP0Image = true, styles = {}, children }) => {
  const isBlackFriday = useInBucket('experiment-black-friday-2023', 'variant')

  const backgroundColor = isBlackFriday
    ? 'var(--color-yellow)'
    : styles?.backgroundColor || getHeroBackgroundColour({ p0 })

  const { imageUrl } = p0?.display || {}

  const showBlackFridayImage = isBlackFriday && p0Fetched.current && (!imageUrl || hideP0Image)

  return (
    <div sx={st.heroWrapper}>
      <CommsUiHero
        maxHeight='auto'
        bgColor={backgroundColor}
        bgImage={backgroundColor}
        isLinearBackground
        sx={styles || st.hero}
      >
        <HeroImageP0 imageUrl={imageUrl} hideP0Image={hideP0Image} />

        <HeroContainer>
          <HeroImageBlackFriday hasP0={notEmpty(p0)} showImage={showBlackFridayImage} />
          {children}
        </HeroContainer>
      </CommsUiHero>
    </div>
  )
}

export default Hero
